import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import classnames from 'classnames';

// Components
import WidgetHeader from 'components/widgetHeader/WidgetHeader';
import DraggableWrapper from 'components/draggableWrapper/DraggableWrapper';
import DroppableWorkspaceSection from 'components/droppableWorkspaceSection/DroppableWorkspaceSection';

import { WIDGET_SIZE } from 'constants.js';

import WorkspaceContext from './WorkspaceContext';
import styles from './workspaceRow.styles';

const { LARGE, SMALL } = WIDGET_SIZE;

export const WorkspaceRowComponent = ({
  allowedSizes = [],
  canDrag,
  classes: { narrow, wide },
  children,
  name,
  rowNumber,
  id = `row-${rowNumber}`,
  removable,
  onRemove,
  onResize,
  size,
  onDrop
}) => {
  const [draggable, setDraggable] = useState(true);

  const onRemoveClick = () => {
    onRemove(id);
  };

  const onResizeClick = () => {
    onResize(id, size === LARGE ? SMALL : LARGE);
  };

  const close = () => setDraggable(false);

  const open = () => setDraggable(true);

  const showResize = allowedSizes && allowedSizes.length > 1;

  return (
    <div
      className={classnames({ [wide]: size === LARGE, [narrow]: size === SMALL })}
      data-qa="workspace-row-unlocked"
    >
      <DroppableWorkspaceSection row={rowNumber} size={size}>
        <DraggableWrapper
          canDrag={canDrag && draggable}
          currentRow={rowNumber}
          handleDrop={onDrop}
          id={rowNumber}
        >
          <div>
            <WidgetHeader
              name={name}
              showResize={showResize}
              showRemove={removable}
              onRemoveClick={onRemoveClick}
              onResizeClick={onResizeClick}
              id={id}
            />
            <div onMouseEnter={close} onMouseOver={close} onFocus={close} onMouseLeave={open}>
              {children}
            </div>
          </div>
        </DraggableWrapper>
      </DroppableWorkspaceSection>
    </div>
  );
};

WorkspaceRowComponent.defaultProps = {
  allowedSizes: ['L', 'S'],
  canDrag: true,
  children: [],
  id: undefined,
  name: '',
  onDrop() {},
  onRemove() {},
  onResize() {},
  rowNumber: 0,
  removable: true,
  size: 'L'
};

WorkspaceRowComponent.propTypes = {
  allowedSizes: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.string)]),
  canDrag: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})])),
    PropTypes.node,
    PropTypes.shape({})
  ]),
  id: PropTypes.string,
  name: PropTypes.string,
  onDrop: PropTypes.func,
  onRemove: PropTypes.func,
  onResize: PropTypes.func,
  removable: PropTypes.bool,
  rowNumber: PropTypes.number,
  size: PropTypes.oneOf(['L', 'S'])
};

const styledWorkspace = withStyles(styles)(WorkspaceRowComponent);
export default WorkspaceContext(styledWorkspace);
